import React, { Component } from "react";

import { ActionCreators } from "../../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { nav } from "../../config/routes";
import { RouteWithSubRoutes } from "../../components/subrouter";

import "../../styles/aoc.css";

class AOCContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSideBarInMobile: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isLoggedin) this.props.push("/oc/login");
  }

  logout() {
    this.props.userLogout();
    this.props.push("/oc/login");
  }

  toggleSideBar() {
    this.setState(prevState => ({
      ...prevState,
      showSideBarInMobile: !this.state.showSideBarInMobile
    }));
  }

  render() {
    return (
      <div className="aoc">
        <div
          className={
            "sidebar " + (this.state.showSideBarInMobile ? "show" : "")
          }
        >
          <div className="sidebar-header">
            <button
              type="button"
              onClick={() => {
                this.toggleSideBar();
              }}
              className="toggler"
            >
              <i className="icon-arrow-left" />
            </button>
            <img src="/images/devstack_logo.png" alt="DevStack" />
          </div>
          <div className="sidebar-body">
            <ul>
              {nav.map((r, i) => {                
                return  (r.name) ? (
                  <li key={i}>
                    <Link to={r.path}>
                      <i className={r.icon + " mr-3"} /> {r.name}
                    </Link>
                  </li>
                ) : "";
              })}
              <li>
                <a
                  onClick={() => {
                    this.logout();
                  }}
                >
                  <i className="icon-logout mr-3" />
                  Logout
                </a>
              </li>
            </ul>
            <div className="col">
              <Link to="/job/open" className="gs-btn gs-btn-blue mt-3 mb-3">
                <i className="icon-screen-desktop mr-3" /> Preview
              </Link>
            </div>
          </div>
        </div>
        <div className="page-wrapper">
          <div className="page-header">
            <button
              type="button"
              onClick={() => {
                this.toggleSideBar();
              }}
              className="toggler"
            >
              <i className="icon-menu" />
            </button>
          </div>
          <div className="page-content">
            {this.props.routes.map((route, i) => (
              <RouteWithSubRoutes key={i} {...route} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedin: state.isLoggedin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AOCContainer)
);



// WEBPACK FOOTER //
// ./src/pages/auth/aocContainer.js